@if (isSuccessful) {
  <span class="ga-tag__label" i18n>Success</span>
}
@if (isFailed) {
  <span class="ga-tag__label" i18n>Error</span>
}
@if (isPending) {
  <ga-spinner size="16" />
}
